import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'jspdf-autotable';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { CaoService } from 'src/app/services/cao.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-farmer-share-to-vendor-pfms-report',
  templateUrl: './farmer-share-to-vendor-pfms-report.component.html',
  styleUrls: ['./farmer-share-to-vendor-pfms-report.component.scss'],
  providers: [DatePipe],
})
export class FarmerShareToVendorPfmsReportComponent implements OnInit {
  @Input() lotDetails: string;
  @ViewChild('farmerShareToVendorPFMSReportTable', { static: true }) 
  public farmerShareToVendorPFMSReportTable: any;

  selectedBankAccounts: any[];

  submitted: boolean;
  menuItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  farmerShareToVendorPFMSReportModel: any[];
  addDialog: boolean;

  lotNo: number;

  public filteredData: any = [];
  selectedStatus: any;
  remarks: String;
  date: any;
  public userID: any;
  miSurveyData: any[];
  items: any[];
  appVerificationItems: MenuItem[];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  public filteredDataForExport: any = [];
  public miCertificateData: any = null;
  public isPrintClicked: boolean = false;
  public printGeneratedDate: any;
  
  ipAddress: any = '000.000.000';
  public loading: boolean = false;
  public loading1: boolean = false;
  public subscriptions: any = [];
  public subjectSub:any;
  public selectedYear:any;
  public isDuplicateFound: boolean = false;

  constructor(
    private messageService: MessageService, 
    private caoService: CaoService, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService, 
    private dashboard: DashboardService,
    private translateService: TranslateService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private datePipe: DatePipe,
    ) { }

  ngOnInit() {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();
    this.getIP();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.farmerShareToVendorPFMSReportModel, "MI Farmer Share To Vendor PFMS Report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.farmerShareToVendorPFMSReportModel, "MI Farmer Share To Vendor PFMS Report");
        }
      },
    ];

    // let actionId = 28; // Do not Change, it is fixed for Farmer Application Verifications
    // this.deptDashBoardService
    //   .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       this.items = data.$values;
    //     },
    //     error: () => {
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: 'Status Master cant be Loaded',
    //       });
    //     },
    //   });

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.miSurveyData, `${this.lotNo}_(${this.date})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
      //   }
      // },
    ];

  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }


  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    if(this.lotDetails){
      this.loadData();
    }else{
      this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
        (res) => {
          this.loadData();
     
          this.selectedYear = res;
          this.farmerShareToVendorPFMSReportTable.filters['FinYear'] = [
            { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
        }
      );
    }
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  refreshTable(){
    this.loadData();
  }

  loadData() {
    // this.loader.start();
    let reqBody = {
      UserType: "Farmer,7500",
      FinYear: ''
    }
    if(this.lotDetails != undefined){
      reqBody = {
        UserType: '',
        FinYear: this.lotDetails?.['F.Y.']
      }
    }

    this.loading = true;
    let sub=this.caoService.miFarmerShareToVendorPFMSReport(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          data = data.map(val => ({ 
            ...val,
            lotNoForSorting: parseInt(val?.Lot_No.slice(7))
          }))
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Report (PDMC)', '', new Date(), 'Success');

          if (data.length > 0) {
            this.farmerShareToVendorPFMSReportModel = data;
          }
          else{
            this.farmerShareToVendorPFMSReportModel = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Report (PDMC)', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error!  not loaded.' });

        }
      });
      this.subscriptions.push(sub);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Srno', header: 'Sr No' },
      { field: 'Lot_No', header: 'File No' },
      { field: 'dateofExport', header: 'Date of Export' },
      { field: 'No_of_Record', header: 'No of Record' },
      { field: 'Sum_of_PFMS_Export', header: 'Sum of PFMS Export' },
      { field: 'No_of_Successfull_Records', header: 'No of Successfull Records' },
      { field: 'Sum_of_Successfull_Records', header: 'Sum of Successfull Records' },
      { field: 'NoOfPendingRecords', header: 'No of Pending Records' },
      { field: 'SumOfPendingRecords', header: 'Sum of Pending Records' },
      { field: 'No_of_Failed_Records', header: 'No of Failed Records' },
      { field: 'Sum_of_Failed_Records', header: 'Sum of Failed Records' },
      { field: 'Sum_of_Bank_Transfer_Successfull_Records', header: 'Sum of Bank Transfer Successfull Records' }
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }


  hideDialog() {
    this.addDialog = false;
    this.miSurveyData = [];
    this.miCertificateData = null;
    this.isDuplicateFound = false;
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Sr No": d.Srno,
          "File No": d.Lot_No,
          "Date of Export": d.dateofExport,
          "No of Record": d.No_of_Record,
          "Sum of PFMS Export": d.Sum_of_PFMS_Export,
          "No of Successfull Records": d.No_of_Successfull_Records,
          "Sum of Successfull Records": d.Sum_of_Successfull_Records,
          "No of Pending Records": d.NoOfPendingRecords,
          "Sum of Pending Records": d.SumOfPendingRecords,
          "No of Failed Records": d.No_of_Failed_Records,
          "Sum of Failed Records": d.Sum_of_Failed_Records,
          "Sum of Bank Transfer Successfull Records": d.Sum_of_Bank_Transfer_Successfull_Records,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // handleClick() {
  //   let newFilteredData = this.filteredData.map(row => ({
  //     ...row,
  //     status: this.selectedStatus.flag,
  //     remarks: this.remarks ? this.remarks : 'undefined',
  //   }))

  //   let reqBody = {
  //     listLotData: newFilteredData,
  //     userID: this.userID,
  //     network_Id: this.ipAddress,
  //     terminal_Id: this.ipAddress,
  //     subSidyType: 'FTV',
  //   }
  //   console.log("reqBody", reqBody)

  //   this.insertMISubsidyLot(reqBody);
  // }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
  

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    // this.loader.start();
    this.loading = true;
    this.deptDashBoardService.insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
          this.pmfsExport(reqBody.Lot_No, '');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  pmfsExport(lotId, status) {
    this.printGeneratedDate = this.toISOLocal(new Date()).replace(/.\d+Z$/g, "")
    this.addDialog = true;
    this.lotNo = lotId;
   // this.loader.start();
   this.loading1 = true;
    this.caoService.miFarmerShareToVendorPFMSExport(lotId, status, 'Farmer,7500')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          // console.log("dataaa", data)
          if (data?.length > 0) {

            const flag = this.hasDuplicate(data);
            if(flag['duplicate'] == true) {
              this.isDuplicateFound = true;
              this.messageService.add({ 
                severity: 'warn', 
                summary: 'Warn Message', 
                detail: `Duplicate values found in the data. Please contact to technical team. Duplicate ${flag['type']} : ${flag['value']}`,
                sticky: true,
                closable: true
              });
            } else {
              this.isDuplicateFound = false;
            }

            this.miSurveyData = data;
            this.miSurveyData = this.miSurveyData.map(row => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat("_", row.ProgramID)
            }))
            // console.log("RTFdata", this.miSurveyData)
          }
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Export (PDMC)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.isDuplicateFound = false;
          // this.loader.close();
          this.miSurveyData = [];
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Export (PDMC)', lotId, new Date(), err);

        }
      });

      this.miCertificateData = null;
      if(status== ''){
        this.caoService.getDataForLotCertificate(lotId, 'Farmer,7500')
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.miCertificateData = data[0];
            this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Export (PDMC) Lot Certificate', lotId, new Date(), 'Success');
          },
          error: (err) => {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
            this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Vendor PFMS Export (PDMC) Lot Certificate', lotId, new Date(), err);

          }
        });
      }
  }

  hasDuplicate(records) {
    const appIds = new Set();
    // const aadhars = new Set();

    for (const item of records) {
      if (appIds.has(item.Scheme_Specific_Id)) {
        return { duplicate: true, type: "AppId", value: item.Scheme_Specific_Id };
      }
      // if (aadhars.has(item.Aadhar_No)) {
      //   return { duplicate: true, type: "Aadhar", value: item.Aadhar_No };
      // }

      appIds.add(item.AppId);
      // aadhars.add(item.Aadhar_No);
    }

    return { duplicate: false };
  }

  selectFarmerApplication(application) {
    if(application.Scheme_Specific_Id){
      // this.loader.start();
    this.loading = true;
      this.dashboard
      .getMIDetailByAppID(application.Scheme_Specific_Id)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loading = false;
          const link = this.router.serializeUrl(
            this.router.createUrlTree([
              this.router.url.split('/')[1],
              'print',
            ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
          // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
          window.open(link, '_blank');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  // onRowSelect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Selected',
  //     detail: event.data.name,
  //   });
  // }

  // onRowUnselect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Unselected',
  //     detail: event.data.name,
  //   });
  // }

  // calculation() {
  //   this.filteredData = [];
  //   // this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;

  //   this.totalSelectedApp = this.filteredDataForExport.length;
  //   this.filteredDataForExport.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   this.filteredDataForExport.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.Scheme_Specific_Id,
  //         programID: val.ProgramID,
  //         subsidy_Amt: 0,
  //         amt_Disbus_to_Vendor: 0,
  //         amt_Refund_to_Farmer: 0,
  //         farmerShareToVendor: val.Farmer_Share_To_Vendor,
  //         state_share_amt: val.State_Share_Payment_Amount,
  //         centre_share_amt: val.Center_Share_Payment_Amount,
  //       })
  //   })
  // }

  pfmsExportExcel(modelData, filename) {
    this.countNoOfTimesExported();
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'File No': this.lotNo,
          'Full Name in English': d.Full_Name_In_English,
          'Full Name in Recognized Official Language': d.Full_Name_in_Recognized_Official_Language,
          'Caste': d.Caste_Description,
          'GST NO': d.GST_NO,
          'Address line 1': d.Address_Line_1,
          'Address Line 2': d.Address_Line_2,
          'Address Line 3': d.Address_Line_3,
          'Village': d.Village,
          'Block': d.Block,
          'District': d.District,
          'State': d.State,
          'Country': d.Country,
          'Farmer Type': d.FarmerType,
          'Vendor Bank Name': d.Vendor_Bank_Name,
          'Vendor IFSCCode': d.Vendor_IFSC_Code,
          'Vendor Account Number': d.Vendor_Account_Number ? d.Vendor_Account_Number.toString() : '',
          'Vendor Pan Card No': d.Vendor_Pan_Card_No,
          'Aadhaar Number': d.Aadhar_No ? d.Aadhar_No.toString() : '',
          'Pincode': d.Pincode,
          'Scheme Specific ID': d.Scheme_Specific_Id,
          'Challan No': d.ChallanNo,
          'UTR': d?.UTR,
          'Credited Date': this.datePipe.transform(new Date(d?.CreditedOnDateTime), 'dd-MM-yyyy'),
          'Challan Amount Deposited': d?.Farmer_Share_To_Vendor,
          'Programme Name': d?.Programme_Name,
          'Crop Name': d?.Crop_Name,
          'User Type': d?.UserType,
          'Application Type': d?.Applicant_type,
          'MI Area': d?.MIArea,
          'Total Area': d?.Total_Area,
          'Remarks': d?.Remarks,
          'CAO Remarks': d?.CAORemarks,
          //user need to enter
          'status': '',
          'remarks': '',
          'PFMS Payment Date': '',
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);

      let dataToSaveForCertificate = [
        // {
        //   'Lot No': this.lotNo,
        //   'Date the lot of print generated': this.miCertificateData?.currentDate,
        //   'Period': `${this.miCertificateData?.prevDate} to ${this.miCertificateData?.currentDate}`,
        //   // 'Statement 1': `Period date ${this.miCertificateData?.prevDate} to date ${this.miCertificateData?.currentDate}`,
        //   'Statement 1': `Total farmer share deposited till date ${this.miCertificateData?.currentDate} total application ${this.miCertificateData?.totalChallanApp} Amount Rs. ${this.miCertificateData?.totalChallanAmount}.`,
        //   'Statement 2': `Detail this lot no. ${this.lotNo } total Application ${this.miCertificateData?.totalLotApp} Amount Rs. ${this.miCertificateData?.totalLotAmount} from date ${this.miCertificateData?.prevDate} to date ${this.miCertificateData?.currentDate}.`,
        //   'Statement 3': `Payment for Farmer share done lot numbers, ${this.miCertificateData?.ImportLot == null ? '____' : this.miCertificateData?.ImportLot} Amount Rs.${this.miCertificateData?.ImportAmt == null ? '____' : this.miCertificateData?.ImportAmt}.`,
        //   'Certificate 1': `The farmer share of ${this.miCertificateData?.totalLotApp} no. of applications for amount Rs. ${this.miCertificateData?.totalLotAmount} has been received as per the portal report. This Lot is submitted for further processing as per the next process of verification and payment approval.`,
        //   'Certificate 2': `It is certified that the farmer share of each applications has been tallied with the bank account passbook and application wise amount has been credited in the Farmer share bank account of MICADA.`,
        //   'Certificate 3': `The ${this.miCertificateData?.totalLotApp} no. of cases for Rs. ${this.miCertificateData?.prevDate} is submitted for approval and payment to ${this.miCertificateData?.NoOfVendors == null ? 0 : this.miCertificateData?.NoOfVendors} no. of vendors as per details of lot ${this.lotNo}.`
        // }

        {
          '': `Lot No: ${this.lotNo}`,
        },
        {
          '': `Date the lot of print generated ${this.printGeneratedDate}`,
        },
        {
          '': `Period: ${this.miCertificateData?.prevDate} to ${this.miCertificateData?.currentDate}`,
        },
        {
          '': ``
        },
        {

          '': `Total farmer share deposited till date ${this.miCertificateData?.currentDate} total application ${this.miCertificateData?.totalChallanApp} Amount Rs. ${this.miCertificateData?.totalChallanAmount}.`,
        },
        {
          '': ``
        },
       
        {

          '': `Detail this lot no. ${this.lotNo } total Application ${this.miCertificateData?.totalLotApp} Amount Rs. ${this.miCertificateData?.totalLotAmount} from date ${this.miCertificateData?.prevDate} to date ${this.miCertificateData?.currentDate}.`,
        },
        {
          '': ``
        },
    
        {
          '': `Payment for Farmer share done lot numbers, ${this.miCertificateData?.ImportLot == null ? '____' : this.miCertificateData?.ImportLot} Amount Rs.${this.miCertificateData?.ImportAmt == null ? '____' : this.miCertificateData?.ImportAmt}.`,
        },
        {
          '': ``
        },
        {
          '': `Certificate 1:`
        },
        {

          '': `The farmer share of ${this.miCertificateData?.totalLotApp} no. of applications for amount Rs. ${this.miCertificateData?.totalLotAmount} has been received as per the portal report.`,
        },
        {
          '': `This Lot is submitted for further processing as per the next process of verification and payment approval.`
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                          Director /MI`
        },
        {
          '': ``
        },
        {
          '': `Certificate 2:`
        },
        {

          '': `It is certified that the farmer share of each applications has been tallied with the bank account passbook`,
        },
        {
          '': `and application wise amount has been credited in the Farmer share bank account of MICADA.`
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                CAO /Accounts Officer`
        },
        {
          '': ``
        },
        {
          '': `Certificate 3:`
        },
        {

          '': `The ${this.miCertificateData?.totalLotApp} no. of cases for Rs. ${this.miCertificateData?.prevDate} is submitted for approval and payment to ${this.miCertificateData?.NoOfVendors == null ? 0 : this.miCertificateData?.NoOfVendors} no. of vendors as per details of lot ${this.lotNo}.`
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                                     `
        },
        {
          '': `                                                                                                                                                                                  CAO`
        }
      ]

      const worksheet2 = xlsx.utils.json_to_sheet(dataToSaveForCertificate);

      const workbook = { Sheets: { data: worksheet, certificate: worksheet2 }, SheetNames: ["data", "certificate"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  countNoOfTimesExported(){
    
    let reqBody = {
      lotType: 'FTV',
      subLotType: '',
      lotNo: this.lotNo,
      userId: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress 
    }

    this.postCountExportDataFrequency(reqBody);
  }

  postCountExportDataFrequency(reqBody) {
    // this.loader.start();
    // this.loading = true;
    this.deptDashBoardService
      .postCountExportDataFrequency(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          // this.loading = false;
          if(data.Result == 'Success'){
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: data.Result,
            });
          }else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data.Result,
            });
          }
          this.loadData();
        },
        error: (err) => {
          // this.loader.close();
          // this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -3) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1 || row.PendingCompletedDays == -2) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }

  // onPrint(divName){
  //   this.isPrintClicked = true;
  //   // var printContents = document.getElementById(divName).innerHTML;
  //   // var originalContents = document.body.innerHTML;        
  //   // document.body.innerHTML = printContents;
  //   // window.print();
  //   // document.body.innerHTML = originalContents;
  //   document.body.style.visibility="hidden";
  //   document.getElementById(divName).style.visibility='visible'
  //   window.print();
  //   document.body.style.visibility="visible";
  // }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return z(d.getDate()) + '/'
      + z(d.getMonth() + 1) + '/' +
      d.getFullYear();
  }
}
